import { useLogger } from "@sg-protect/federation-runtime/squide";
import { ChunkLoadError, isChunkLoadError } from "./layouts/ChunkLoadError.tsx";
import { InternalServerError } from "./layouts/InternalServerError.tsx";
import { NotFoundError } from "./layouts/NotFoundError.tsx";
import config from "@sg-protect/runtime-config";
import { useEffect } from "react";
import { isRouteErrorResponse, useLocation, useRouteError } from "react-router";

export interface RootErrorBoundaryProps {
    error?: unknown;
}

export function RootErrorBoundary({ error }: RootErrorBoundaryProps) {
    const location = useLocation();

    const logger = useLogger();

    useEffect(() => {
        logger
            .withText(`[shell] An unmanaged error occurred while rendering the route with path ${location.pathname}`)
            .withError(error as Error)
            .error();
    }, [logger, error, location]);

    if (isChunkLoadError(error)) {
        return <ChunkLoadError />;
    }

    // Handles 404 Response thrown from React Router's loaders.
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            return <NotFoundError homeUrl={config.get().home.baseUrl} />;
        }
    }

    // Should usually only handles HTTP 500 error but it's currently also used as the default
    // error screen since it's the root error boundary.
    return <InternalServerError homeUrl={config.get().home.baseUrl} />;
}

export function ConnectedRootErrorBoundary() {
    const error = useRouteError();

    return <RootErrorBoundary error={error} />;
}
